import { makeStyles } from "@material-ui/core";
import { Box, Grid } from "@mui/material";

import karstenImage from "assets/img/logos/karstenWhite.webp";
import trussardiImage from "assets/img/logos/trussardiWhite.webp";
import KarstenDecorImage from "assets/img/logos/karstenDecor.webp";
import themeColorsDesingSystem from "assets/theme/ds-colors";

const useCustomStyles = makeStyles({
  imgCard: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "1rem 0",
  },
  title: {
    color: themeColorsDesingSystem.background.dark,
    fontSize: "2.5rem",
    marginTop: "1rem",
  },
  inputAdornedStart: {
    paddingLeft: 0,
  },
})

export default function Header() {
  const classes = useCustomStyles()

  return (
    <Grid container justifyContent="center" style={{ margin: 0 }}>
      <Grid
        item
        xs={4}
        className={classes.imgCard}
        style={{ backgroundColor: themeColorsDesingSystem.stone.medium }}
      >
        <Box
          component="img"
          src={karstenImage}
          alt="logo da karsten"
          maxWidth="20vw"
          maxHeight="5vh"
        />
      </Grid>
      <Grid
        item
        xs={4}
        className={classes.imgCard}
        style={{ backgroundColor: themeColorsDesingSystem.stone.dark }}
      >
        <Box
          component="img"
          src={KarstenDecorImage}
          alt="logo da karsten"
          maxWidth="20vw"
          maxHeight="5vh"
        />
      </Grid>
      <Grid
        item
        xs={4}
        className={classes.imgCard}
        style={{ backgroundColor: themeColorsDesingSystem.background.dark }}
      >
        <Box
          component="img"
          src={trussardiImage}
          alt="logo da karsten"
          maxWidth="20vw"
          maxHeight="5vh"
        />
      </Grid>
    </Grid>
  );
}